import { render, staticRenderFns } from "./OilPalmClusters.vue?vue&type=template&id=017791d2&scoped=true&"
import script from "./OilPalmClusters.vue?vue&type=script&lang=js&"
export * from "./OilPalmClusters.vue?vue&type=script&lang=js&"
import style0 from "./OilPalmClusters.vue?vue&type=style&index=0&id=017791d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "017791d2",
  null
  
)

export default component.exports